import { Skeleton, Stack } from "@mui/material";

export function YourChartingLoginBottomSheetSkeleton() {
  return (
    <Stack spacing={4} sx={{ paddingX: 5, paddingBottom: 8 }}>
      <Skeleton variant="circular" width={64} height={64} sx={{ alignSelf: "center" }} />
      <Skeleton variant="text" width="60%" sx={{ alignSelf: "center" }} />
      <Skeleton variant="text" width="80%" sx={{ alignSelf: "center" }} />
      <Skeleton variant="rounded" height={48} />
      <Skeleton variant="rounded" height={48} />
    </Stack>
  );
}
